import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hide", "show"]
  static values = { preventDefault: { type: Boolean, default: true } }

  toggle(event) {
    if (this.preventDefaultValue) {
      event.preventDefault()
    }

    this.hideTargets.forEach((target) => {
      target.classList.toggle("hidden")
    })

    this.showTargets.forEach((target) => {
      target.classList.toggle("hidden")
    })
  }
}
